const MOOSE_REACT_LEARN_ACCESS_TOKEN = "gis_app_token";
export const utilyUtil = {
    queryCsdnGpt: function (e) {
        window.location.href = "https://so.csdn.net/so/search?q=js"+e.message;
    },
    saveAccessToken:function(token){
        localStorage.setItem(MOOSE_REACT_LEARN_ACCESS_TOKEN,token);;
    },
    getAccessToken:function(){
        return localStorage.getItem(MOOSE_REACT_LEARN_ACCESS_TOKEN) || 'MOOSE_REACT_LEARN';
    },
    removeAccessToken:function(){
        localStorage.removeItem(MOOSE_REACT_LEARN_ACCESS_TOKEN);
    },
    getAuthorization:function(){
        let accessToken = this.getAccessToken();
        return {
            Authorization:`${accessToken}`,
        };
    },
}